import qs from 'qs';

export default {
    mode: 'history',
    defaultRoute: { name: 'guest.login' },
    linkActiveClass: 'bg-state-selected text-state-selected',
    parseQuery(query) {
        return qs.parse(query);
    },
    stringifyQuery(query) {
        var result = qs.stringify(query, { encode: false });

        return result ? result : '';
    },
};
